exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, " .menu-item-submenu{\r\n    width: 80%; \r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-align: left;\r\n    max-width: -webkit-max-content;\r\n    max-width: -moz-max-content;\r\n    max-width: max-content;\r\n} ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/navigation/navigation.component.css
// module id = ../../../../../src/app/shared/layout/navigation/navigation.component.css
// module chunks = main